const initialPincode = {
    pincodePermissions:{},
    pincodeLists: [],
    pincodeStatus: [],
    changedPincodeStatus : [],
    loadingPincode: false,
    errorsPincode: {}
}

const  pincodeReducer = (state = initialPincode, action) => {
    switch (action.type) {
        case "GET_PINCODELIST_PENDING":
        case "ADD_PINCODE_PENDING":
        case "UPDATE_PINCODE_PENDING":
        case "UPDATE_PINCODE_STATUS_PENDING":
        case "DELETE_PINCODE_PENDING":
        case "GET_PINCODELISTBYID_PENDING":
            return { ...state, loadingPincode: true };

        case "GET_PINCODELIST_FULFILLED":
            return {
                ...state,
                loadingPincode: false,
                pincodeLists: action.payload,
                pincodeCount: action.pincodeCount,
                pincodePermissions:action.permissions,
            };

        case "ADD_PINCODE_FULFILLED":
            return {
                ...state,
                loadingPincode: false,
                changedPincodeStatus: action.payload,
            };

        case "UPDATE_PINCODE_FULFILLED":
            return {
                ...state,
                loadingPincode: false,
                changedPincodeStatus: action.payload,
            };

        case "UPDATE_PINCODE_STATUS_FULFILLED":
                return {
                    ...state,
                    loadingPincode: false,
                    changedPincodeStatus: action.payload,
                };

        case "GET_PINCODELISTBYID_FULFILLED":
            return {
                ...state,
                loadingPincode: false,
                pincodeLists: action.payload
            };

        case "DELETE_PINCODE_FULFILLED":
            return {
                ...state,
                loadingPincode: false,
                changedPincodeStatus: action.payload
            };

        case "RESET_DELETE_PINCODE_STATUS":
            return {
                ...state,
                loadingPincode: false,
                changedPincodeStatus: [],
                errorsPincode:{}
            };

        case "GET_PINCODELIST_REJECTED":
        case "ADD_PINCODE_REJECTED":
        case "UPDATE_PINCODE_REJECTED":
        case "UPDATE_PINCODE_STATUS_REJECTED":
        case "DELETE_PINCODE_REJECTED":
        case "GET_PINCODELISTBYID_REJECTED":
            return {
                ...state,
                loadingPincode: false,
                errorsPincode: action.payload
            };

        default:
            return state;
    }
}

export default pincodeReducer;